var chunkMapping = {
	"0": [
		4937
	],
	"76": [
		5055
	],
	"151": [
		5130
	],
	"152": [
		5131
	],
	"155": [
		5134
	],
	"156": [
		5135
	],
	"157": [
		5136
	],
	"158": [
		5137
	],
	"159": [
		5138
	],
	"160": [
		5139
	],
	"161": [
		5140
	],
	"162": [
		5141
	],
	"163": [
		5142
	],
	"164": [
		5143
	],
	"165": [
		5144
	],
	"166": [
		5145
	],
	"167": [
		5146
	],
	"168": [
		5147
	],
	"169": [
		5148
	],
	"170": [
		5149
	],
	"171": [
		5150
	]
};
var idToExternalAndNameMapping = {
	"4937": [
		"default",
		"./Containers",
		3807
	],
	"5055": [
		"default",
		"./OrderlessInvoices",
		3807
	],
	"5130": [
		"default",
		"./AsyncEventTracker",
		3807
	],
	"5131": [
		"default",
		"./HostWrapper",
		3807
	],
	"5134": [
		"default",
		"./CheckoutV3",
		3807
	],
	"5135": [
		"default",
		"./CheckoutConfirmation",
		3807
	],
	"5136": [
		"default",
		"./ContactCreditCards",
		3807
	],
	"5137": [
		"default",
		"./AuditDialog",
		3807
	],
	"5138": [
		"default",
		"./InvoiceBlocksOrderDialog",
		3807
	],
	"5139": [
		"default",
		"./InvoiceDialog",
		3807
	],
	"5140": [
		"default",
		"./PaymentDueModal",
		3807
	],
	"5141": [
		"default",
		"./PaymentModal",
		3807
	],
	"5142": [
		"default",
		"./PaymentHistory",
		3807
	],
	"5143": [
		"default",
		"./PaymentConfigurations",
		3807
	],
	"5144": [
		"default",
		"./PaymentPreferences",
		3807
	],
	"5145": [
		"default",
		"./ManagePaymentProcessing",
		3807
	],
	"5146": [
		"default",
		"./MobilePaymentsWrapper",
		3807
	],
	"5147": [
		"default",
		"./Challenge",
		3807
	],
	"5148": [
		"default",
		"./ManagePaymentMethods",
		3807
	],
	"5149": [
		"default",
		"./LightspeedReports",
		3807
	],
	"5150": [
		"default",
		"./ShippingPromotionsListContainer",
		3807
	]
};
var idToRemoteMap = {
	"4937": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3807
		}
	],
	"5055": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3807
		}
	],
	"5130": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3807
		}
	],
	"5131": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3807
		}
	],
	"5134": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3807
		}
	],
	"5135": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3807
		}
	],
	"5136": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3807
		}
	],
	"5137": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3807
		}
	],
	"5138": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3807
		}
	],
	"5139": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3807
		}
	],
	"5140": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3807
		}
	],
	"5141": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3807
		}
	],
	"5142": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3807
		}
	],
	"5143": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3807
		}
	],
	"5144": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3807
		}
	],
	"5145": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3807
		}
	],
	"5146": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3807
		}
	],
	"5147": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3807
		}
	],
	"5148": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3807
		}
	],
	"5149": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3807
		}
	],
	"5150": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3807
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes = {idToRemoteMap,chunkMapping, idToExternalAndNameMapping, webpackRequire:__webpack_require__};
__webpack_require__.f.remotes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}